import connection from './connection.js'

const list = async function (page, per_page,key, callback) {
  const url = '/admin/member/list';
  let q = {};
  key && (q.keywords = key);
  let {
    error,
    data
  } = await connection.query(url, {
    page: page,
    per_page: per_page,
    q,
  })
  if (callback) callback(error, data)
};


const getAddDetail = async function (id, callback) {
  const url = `/admin/member/address/detail/${id}`;
  let {
    error,
    data
  } = await connection.query(url)
  if (callback) callback(error, data)
}

const updateMemberAble = async function (params, id, callback) {
  const url = `/admin/member/status/update/${id}`
  let {
    error,
    data
  } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const editAddress = async function (params, id, callback) {
  const url = `/admin/member/address/update/${id}`
  let {
    error,
    data
  } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const deleteData = async function (params, callback) {
  const url = `/admin/member/delete`;
  let pa = {userId: String(`[${params}]`)}
  let {
    error,
    data
  } = await connection.update(url, pa)
  if (callback) callback(error, data)
}



export default {
  list: list,
  getAddDetail: getAddDetail,
  updateMemberAble: updateMemberAble,
  editAddress: editAddress,
  deleteData: deleteData
}
